import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const ExternalLinks = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "external-links" */ './external-links')),
    LoadingSkeleton: () => null,
});
